import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../../../../store';

export const Timer = observer(() => {
  const { time } = gameStore;
  return <p className='timer-wheel'>{time || 0}</p>;
});
